import ReactHtmlParser from 'react-html-parser';
import { useTranslation } from 'react-i18next';
import useHorizontalCarousel from "../Compartido/useHorizontalCarousel";
import { RUTA_IMATGES, OPINIONES } from '../Compartido/contenidoCamprodon.js';
import ControlesSlider from './ControlesSlider.jsx';

const Estrellas = ({ cuantas }) => (
    <div className="c-review__stars">
        {[1, 2, 3, 4, 5].map((n) => (
            <svg aria-hidden="true" focusable="false" className="c-icon c-icon--ico-star" key={n}>
                <use href={RUTA_IMATGES + "icons-sprite.svg#" + (n <= cuantas ? "sprite-icon-ico-star-yes" : "sprite-icon-ico-star-no")}></use>
            </svg>
        ))}
    </div>
);

// "Què opinen els nostres clients?": les valoracions de BedLoop si el
// client les té actives; si no, les del disseny.
const Comentarios = ({ comentarios, lang, config, ruta }) => {

    const { t } = useTranslation();

    let coms = [];

    if (config.activa_comentarios_web == 1 && comentarios.length > 0) {
        comentarios.forEach((uncomentario, index) => {
            const primerTexto = Object.values(uncomentario.texto || {}).find(Boolean);
            coms.push({
                id: index,
                identificador: uncomentario.id,
                texto: uncomentario.texto?.[lang] || primerTexto,
                estrellas: uncomentario.estrellas,
                persona: uncomentario.nombre_persona,
                detalle: uncomentario.propiedad ? uncomentario.propiedad.nombre : "",
                imagen: uncomentario.imagen,
                html: true,
            });
        });
    } else {
        // País en l'idioma de la web, sense clau de traducció pròpia.
        let espanya = "España";
        try {
            espanya = new Intl.DisplayNames([lang || "es"], { type: "region" }).of("ES");
        } catch (e) { }
        coms = OPINIONES.map((opinion, index) => ({
            id: index,
            texto: opinion.texto,
            estrellas: 5,
            persona: opinion.nombre,
            detalle: espanya,
        }));
    }

    const { trackRef, navState, scrollByCard } = useHorizontalCarousel('.c-review', coms.length);

    if (coms.length === 0) return null;

    return (
        <section className="reviews o-container">
            <div className="reviews__title text-center">{t("¿Qué opinan nuestros clientes?")}</div>
            <div className="c-reviews-slider">
                <div className="hc-js-slider" ref={trackRef}>
                    {coms.map((comentario) => (
                            <div className="c-review text-center" key={comentario.id}>
                                {comentario.imagen &&
                                    <div className="c-review__avatar">
                                        <img src={ruta + "/comentarios/" + comentario.identificador + "/" + comentario.imagen} alt={comentario.persona} />
                                    </div>
                                }
                                <Estrellas cuantas={comentario.estrellas} />
                                {comentario.html
                                    ? <div>{ReactHtmlParser(comentario.texto)}</div>
                                    : <p>{comentario.texto}</p>
                                }
                                <div className="c-review__by">
                                    <strong>{comentario.persona}</strong>{comentario.detalle && <> - {comentario.detalle}</>}
                                </div>
                            </div>
                    ))}
                </div>
                {coms.length > 1 && (
                    <ControlesSlider
                        className="inline-center"
                        onPrev={() => scrollByCard(-1)}
                        onNext={() => scrollByCard(1)}
                        prevDisabled={navState.atStart}
                        nextDisabled={navState.atEnd}
                    />
                )}
            </div>
        </section>
    );
};
export default Comentarios;
